import { render, staticRenderFns } from "./NewYears_foodItem.vue?vue&type=template&id=11f5641e&scoped=true"
import script from "./NewYears_foodItem.vue?vue&type=script&lang=ts"
export * from "./NewYears_foodItem.vue?vue&type=script&lang=ts"
import style0 from "./NewYears_foodItem.vue?vue&type=style&index=0&id=11f5641e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11f5641e",
  null
  
)

export default component.exports